import styled from 'styled-components'
import Flex from 'Components/Flex'

import { NoMarginRow } from 'Components/EnhacedFlexboxGrid'
import { Col } from 'react-styled-flexboxgrid-tmp'


import {
  LIGHT_BACKGROUND,
} from '@CSSVars/colors'


export const _ChartsRow = styled(NoMarginRow)`
  margin: 8px -2px;
  flex-wrap: wrap;
  flex: 0 1 auto;
`

export const _Col = styled(Col)`
  padding: 2px;

`

export const _ChartBlock = styled(Flex)`
  width: 100%;
  height: 100px;
  padding: 12px;
  background-color: ${LIGHT_BACKGROUND};
  border-radius: 10px;
`
